import { BarChartData, TooltipContainer, TooltipInterfaceProps } from '@frontend/charts';
import { Trans } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, Text } from '@frontend/design-system';
import { COMPARED_TIME, ComparisonData, tooltipTheme } from './tooltip';

type TooltipProps = {
  comparisonData: ComparisonData[];
  actualData: BarChartData;
};

export const answerRateTooltipRenderer = ({ actualData, comparisonData }: TooltipProps) =>
  function Tooltip(props: TooltipInterfaceProps) {
    const tooltipData = props.data[0];
    const formattedValue =
      actualData.groups.find((group) => group.name === tooltipData.groupId)?.values[tooltipData.id] ?? 0;
    const compData = comparisonData.find((group) => group.name === tooltipData.groupId);
    const sentiment = compData?.comparison[tooltipData.id].sentiment ?? 'neutral';
    const direction = compData?.comparison[tooltipData.id].direction ?? 'nochange';
    const percentageLabel = compData?.comparison[tooltipData.id].percentage + '%';
    const comparedTimeLabel = COMPARED_TIME[compData?.timeRangeDefinition ?? 'td'];

    return (
      <TooltipContainer {...props}>
        <div style={{ background: 'white', padding: theme.spacing(2), display: 'grid' }}>
          <Text color='subdued'>{tooltipData.label}</Text>
          <Text weight='bold' css={{ fontSize: 24 }}>
            {formattedValue}
          </Text>
          {compData?.timeRangeDefinition !== 'custom' && (
            <div style={{ display: 'grid', gap: theme.spacing(1), gridTemplateColumns: 'auto 1fr' }}>
              {compData?.comparison[tooltipData.id].percentage === 0 ? (
                /**
                 * If the percentage is 0, we don't want to show the percentage value
                 */
                <Trans ns='phone' values={{ time: comparedTimeLabel }}>
                  <Chip variant={tooltipTheme.sentiment[sentiment]['variant']}>
                    <Icon name={tooltipTheme.direction[direction].icon} />
                  </Chip>{' '}
                  <Text color='subdued'>from {{ time: comparedTimeLabel }}</Text>
                </Trans>
              ) : (
                <Trans ns='phone' values={{ percentageLabel, time: comparedTimeLabel }}>
                  <Chip
                    variant={tooltipTheme.sentiment[sentiment]['variant']}
                    leftElement={<Icon name={tooltipTheme.direction[direction].icon} />}
                  >
                    {percentageLabel}
                  </Chip>{' '}
                  <Text color='subdued'>from {{ time: comparedTimeLabel }}</Text>
                </Trans>
              )}
            </div>
          )}
        </div>
      </TooltipContainer>
    );
  };
